module.exports = __webpack_public_path__ + "img/xsth.fc8d44da.png";